module.exports = __webpack_public_path__ + "static/media/grin-stars.2cb25d2e.svg";